import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NotificationComponent } from './notification.component';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		NgbModule
	],
	declarations: [
		NotificationComponent
	],
	exports: [
		NotificationComponent
	]
})
export class NotificationComponentModule { }
